import {StateLabel} from "@platform/models/state-labels/state-label"
import {NextActor} from "@generated"

export const NextActorLabels: Map<NextActor, StateLabel<NextActor>> = new Map([
    [NextActor.Customer, {label: "Customer", background: "#f13536", state: NextActor.Customer, legacyId: 100}],
    [NextActor.ProjectManager, {label: "Project Manager", background: "#989898", state: NextActor.ProjectManager, legacyId: 200}],
    [NextActor.Team1, {label: "Team 1", background: "#40c4ff", state: NextActor.Team1, legacyId: 300}],
    [NextActor.Team2, {label: "Team 2", background: "#ffab4a", state: NextActor.Team2, legacyId: 400}],
])
